import { FC, useEffect, useState } from "react";
import "./share-form.scss";
import { FormShareMode, ShareFormData } from "@archetypes/form";
import { Controller, useForm } from "react-hook-form";
import { RadioGroup } from "@components/radio";
import { useMutation } from "@apollo/client/react";
import { DISTRIBUTE_FORM } from "@queries/index";
import { Button } from "@components/button";
import { Textbox } from "@components/textbox";
import { CopyIcon, LinkIcon } from "@components/icons";
import { CustomTooltip } from "@components/tool-tip";

interface ShareFormProps {
  appId?: string;
  formId?: string;
}

const FormShareModes = [FormShareMode.LIMITED, FormShareMode.PUBLIC];

export const ShareForm: FC<ShareFormProps> = ({ appId, formId }) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useForm<ShareFormData>();

  const mode = watch("mode");

  const [publicUrl, setPublicUrl] = useState<string>();

  const [distributeForm] = useMutation<{ distributeForm: { url: string } }>(DISTRIBUTE_FORM);

  useEffect(() => {
    if (mode === FormShareMode.PUBLIC) {
      distributeForm({
        variables: {
          input: {
            appId,
            formId,
            distributedData: {
              public: true,
            },
          },
        },
      }).then((res) => {
        setPublicUrl(res.data?.distributeForm?.url);
      });
    }
  }, [appId, distributeForm, formId, mode]);

  return (
    <form noValidate>
      <Controller
        name="mode"
        control={control}
        render={({ field }) => (
          <RadioGroup
            value={field.value}
            onChange={field.onChange}
            errorMessage={errors.mode && errors.mode.message}
            getKey={(v: FormShareMode) => v}
            getLabel={(v: FormShareMode) => v}
            getValue={(v?: FormShareMode) => v || ""}
            options={FormShareModes}
            optionClassName="radio-item"
          />
        )}
      />
      {mode === FormShareMode.PUBLIC && publicUrl && (
        <Textbox
          type="text"
          placeholder="URL..."
          containerClassName="input"
          value={publicUrl}
          fieldIcon={<LinkIcon />}
        >
          <Button
            type="button"
            onClick={() => {
              navigator.clipboard.writeText(publicUrl);
            }}
          >
            <CustomTooltip content="Copy" direction="top">
              <CopyIcon />
            </CustomTooltip>
          </Button>
        </Textbox>
      )}
      {/* <PanelFooter>
        <Button type="button" variant="default-bordered" onClick={onClose} className="mr-10">
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </PanelFooter> */}
    </form>
  );
};
